<template>
  <section class="header wrapper">
    <div class="header-logo">
      <a class="btn-link" style="margin-right:30px;" href="/"><img src="../../assets/images/logo.png"></a>
      <!-- <img src="../../assets/images/yixinglogo2.png" style="width:200px;"> -->
      <!-- <a class="btn-link" href="/"><img src="../../assets/images/logo2.png"></a> -->
    </div>
    <div class="header-bar">
      <a class="btn-link" style="  position: absolute;top: 50%;left: 50%; transform: translate(-50%, -50%);" href="http://ysfw.mot.gov.cn/NetRoadCGSS-web/"><img style="max-width:550px" src="../../assets/images/logo3.png"></a>
      <span class="header-bar-item news" @click="utils.toUrl('/set/news-list')">
        <i class="xy xy-icon3 icon-new"></i>
        <span class="round" v-if="$root.newsNum>0">{{$root.newsNum}}</span>
      </span>
      <i class="v-line"></i>
      <span class="header-bar-item user">{{cardName}}</span>
      <el-button class="btn-quit" @click="quit"><i class="xy xy-icon6"></i>退出</el-button>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      userInfo: {},
      newsNum: 0
    };
  },
  created () {
    // this.userInfo = this.utils.getCurrentUserInfo()
    this.getNewsNum()
  },
  props: {
    cardName: {
      required: false,
      type: String,
      default: " "
    }
  },
  methods: {
    quit () {
      localStorage.clear();
      this.utils.toUrl('/auth/login')
    },
    getNewsNum () {
      this.api(154704, {}).then(res => {
        let data;
        if ((data = this.utils.isSuccess(res))) {
          this.$root.newsNum = data.unread;
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.header {
  font-size: 16px;
}
.header-logo {
  height: 90px;
  display: flex;
  align-items: center;
  margin-right: 40px;
}
.btn-link {
  display: flex;
  align-items: center;
}
.header-bar {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.header-bar-item {
  position: relative;
}
.icon-new {
  font-size: 28px;
  color: #999;
  cursor: pointer;
}
.v-line {
  display: inline-block;
  width: 1px;
  background: #e5e5e5;
  height: 16px;
  margin-left: 15px;
  margin-right: 15px;
}
.user {
  margin-right: 50px;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.round {
  transform: scale(0.7);
  position: absolute;
  right: -18px;
  top: -8px;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/master/master-head-navigation.vue